import React from 'react'
import ReactDOM from 'react-dom'
import * as topojson from 'topojson-client'

import { BaseMap } from './base-map'
import { convertRegionDataFromR } from './region-data'
import globalTopology from './topology/global-countries.json'
import letterCodes from './topology/global-country-mapping.json'
import { TooltipContextProvider } from '../../common/tooltip/tooltip.context'

const topology = getCountryTopology(globalTopology)

const DEFAULT_WIDTH = 1024
const DEFAULT_HEIGHT = 550

export const GlobalMap = ({ useLetterCodes = false, width = DEFAULT_WIDTH, height = width / (DEFAULT_WIDTH / 550), enableZoom = false, mapKeyPosition, ...props }) => {
  // Key is absolutely positioned within the div wrapper around the SVG
  mapKeyPosition = mapKeyPosition || {
    bottom: height / 11, // 50px when container height is 550px
    left: width / 20.48 // 50px when container width is 1024px
  }

  const mapRegionInfo = (x) => {
    // if using ids, convert to number because its harder to get input data with leading zeros
    let code = useLetterCodes ? letterCodes[x.id] : Number(x.id)

    // Some features don't have an id
    if (!useLetterCodes && isNaN(code)) {
      code = undefined
    }

    return {
      code,
      name: x.properties.name
    }
  }

  return (
    <TooltipContextProvider>
      <BaseMap
        width={width}
        height={height}
        topology={topology}
        mapRegionInfo={mapRegionInfo}
        regionLabel="country"
        projectionProps={{
          scale: 135 * (width / DEFAULT_WIDTH),
          translate: [ width / 2, (height / 2) + 116 * (height / DEFAULT_HEIGHT) ],
          rotate: [ -10, 0 ]
        }}
        enableZoom={enableZoom}
        mapKeyPosition={mapKeyPosition}
        {...props}
      />
    </TooltipContextProvider>
  )
}

export async function globalMapWidget (id, { regionData, width, height, ...props }) {
  regionData = convertRegionDataFromR(regionData)

  // In R, NA maps to null (not undefined)
  const nullablePropsToIgnore = [ 'scaleOptions' ]
  nullablePropsToIgnore.forEach((prop) => {
    if (props[prop] === null) {
      delete props[prop]
    }
  })

  const element = document.getElementById(id)
  ReactDOM.render(
    React.createElement(GlobalMap, { regionData, ...props }),
    element
  )
}

function getCountryTopology (topoJsonTopology) {
  return topojson.feature(topoJsonTopology, topoJsonTopology.objects.countries)
}
